<script>
  export let header = "";
  export let text = "";

  export let width;
  export let height;

  export let top;
  export let left;

  export let position = "absolute";

  $: cardWrapperStyle = `width: ${width}px; height: ${height}px; top: ${top}px; left: ${left}px; position: ${position}`;
</script>

<div class="card-wrapper" style={cardWrapperStyle}>
  <div class="card-icon">
    <slot />
    <h1 class="card-title">{header}</h1>
    <p class="card-text">{text}</p>
  </div>
</div>

<style>
  /* All values are harcoded according to Figma's design */
  .card-wrapper {
    background: #ffffff;
    box-shadow: 0px 10px 36px rgba(86, 102, 237, 0.19);
    border-radius: 14px;
  }

  .card-icon {
    position: absolute;
    left: 24px;
    top: 24px;
  }

  .card-title {
    position: absolute;

    left: 24px;
    top: 64px;

    /* H3 */
    white-space: nowrap;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;

    /* identical to box height */

    /* Black */
    color: #2b292d;
  }

  .card-text {
    /* H4 */

    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 150%;

    margin-top: 65px;
    margin-right: 12px;

    /* or 21px */

    /* Gray */
    color: #6e6e6e;
  }
</style>
